import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getPagesListByBrand } from "../api/getPagesListByBrand";
import { Page } from "../types";

export const usePagesListByBrandQuery = (brandId: string) => {
  return useQuery({
    queryKey: ["pages", brandId],
    queryFn: () => getPagesListByBrand(brandId),
  });
};

export const invalidatePagesListByBrandsQuery = (brandId: string) => {
  return queryClient.invalidateQueries({
    queryKey: ["pages", brandId],
  });
};

export const getPagesListByBrandQueryData = (brandId: string) => {
  return queryClient.getQueryData<Page[]>(["pages", brandId]);
};

export const setPagesListByBrandQueryData = (brandId: string, data: any) => {
  return queryClient.setQueryData(["pages", brandId], data);
};
